import React, { useEffect, useState } from "react";
import Loader from "../Loader/loader";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { axiosGet, axiosPatch, axiosPost } from "../../common/utils/helper";
import {
  getFeedbackQuestion,
  saveCandidateFeedback,
} from "../../common/utils/api";
import "../manageRequest/addRequest.scss";
import { EPInput } from "../../common/controls";
import { toast } from "react-toastify";
import { CommonConstants } from "../../common/utils/CommonConstants";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";

interface Feedback {
  QuestionId: string;
  Answer: string;
}
export default function CandidateFeedback() {
  const [loading, setLoading] = useState(false);
  const [questionList, setQuestionList] = useState([]);
  const [feedback, setFeedback] = useState<Feedback[]>([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getFeedbackQuestions();
  }, []);

  const getFeedbackQuestions = () => {
    setLoading(true);
    axiosGet(getFeedbackQuestion)
      .then((res: any) => {
        setQuestionList(res.data.data);
      })
      .catch((e) => {
        console.log("e", e);
      });
    setLoading(false);
  };

  const handleOnChange = (
    questionId: string,
    answer: string,
    isReason?: boolean
  ) => {
    if (isReason) {
      setQuestionList((prevQuestions: any) =>
        prevQuestions.map((question: any) => {
          return question.Id === questionId
            ? {
                ...question,
                Reason: answer,
              }
            : question;
        })
      );
    } else {
      setQuestionList((prevQuestions: any) =>
        prevQuestions.map((question: any) => {
          return question.Id === questionId
            ? {
                ...question,
                Answer:
                  question.Answer.length > 0 &&
                  question.AnswerType === "multiple_choice"
                    ? question.Answer.split(", ").includes(answer)
                      ? question.Answer.split(", ") // If answer is already selected, remove it
                          .filter((ans: string) => ans !== answer)
                          .join(", ")
                      : `${question.Answer}, ${answer}`
                    : answer,
              }
            : question;
        })
      );
    }
  };

  const validateAnswers = (questions: any[]) => {
    return questions.some(
      (question: any) =>
        question.IsMandatory &&
        (question.Answer === null || question.Answer === "")
    );
  };

  const onSubmit = async () => {
    setIsSubmitted(true);
    if (!validateAnswers(questionList)) {
      const response: AxiosResponse = (await axiosPost(saveCandidateFeedback, {
        feedback: questionList,
      })) as AxiosResponse;

      if (
        response.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
        response.data?.status === "success"
      ) {
        setLoading(false);
        toast.success("Successfully submitted", {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate("/success", { state: { message: "Thank you for your feedback!" } });
      } else if (
        response.status == CommonConstants.API_RESPONSE_INTERNAL_SERVER_ERROR &&
        response.data?.status === "error"
      ) {
        setLoading(false);
        toast.warning("Something went wrong!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error("Please fill mandatory fields!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onCancel = () => {
    setQuestionList((prevQuestions: any) =>
      prevQuestions.map((question: any) => {
        return {
          ...question,
          Answer: "",
        };
      })
    );
  };

  return loading ? (
    <Loader />
  ) : (
    <Card className="card-managerequest candidate-feedback">
      <Card.Body>
        <Form>
          {questionList?.map((question: any, index) => {
            return (
              <Row key={index}>
                <Form.Group as={Col} lg="12" md="12">
                  <div className="form-group">
                    <label className="form-label">
                      {question.Question}
                      {question.IsMandatory && <span>*</span>}
                    </label>
                    <Row>
                      {(question.AnswerType === "multiple_choice" ||
                        question.AnswerType === "boolean") &&
                        question.Options.map(
                          (option: any, optionIndex: number) => {
                            return (
                              <Col lg="2" key={optionIndex}>
                                <div
                                  className={`form-group radio-border checkbox mt-0 mb-0 ${
                                    isSubmitted &&
                                    question.IsMandatory &&
                                    !question.Answer
                                      ? "radioError"
                                      : ""
                                  }`}
                                >
                                  <Form.Check
                                    inline
                                    label={option}
                                    name={question.Question}
                                    type={
                                      question.AnswerType === "multiple_choice"
                                        ? "checkbox"
                                        : "radio"
                                    }
                                    onChange={(value: any) => {
                                      handleOnChange(question.Id, option);
                                    }}
                                    checked={
                                      question.Answer &&
                                      ((question.AnswerType ===
                                        "multiple_choice" &&
                                        question.Answer.split(", ").includes(
                                          option
                                        )) ||
                                        (question.AnswerType === "boolean" &&
                                          question.Answer.includes(option)))
                                        ? true
                                        : false
                                    }
                                  />
                                </div>
                              </Col>
                            );
                          }
                        )}
                    </Row>
                    {(question.AnswerType === "text" ||
                      question.Answer.includes(question.ReasonFor)) && (
                      <EPInput
                        isValidate={
                          isSubmitted &&
                          question.IsMandatory &&
                          (question.Answer === null || question.Answer === "")
                        }
                        minlength={3}
                        maxlength={5000}
                        type="text"
                        onChange={(val: string) => {
                          handleOnChange(
                            question.Id,
                            val,
                            question.Answer.includes(question.ReasonFor)
                          );
                        }}
                        value={
                          question.Answer.includes(question.ReasonFor)
                            ? question?.Reason
                            : question?.Answer
                        }
                      />
                    )}
                  </div>
                </Form.Group>
              </Row>
            );
          })}
          <Row className="float-start mt-1">
            <Col>
              <Button type="button" onClick={() => onSubmit()}>
                Submit
              </Button>
            </Col>
            <Col>
              <Button onClick={() => onCancel()} type="button" className="cancel-btn">
                Reset
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
}
